import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { TocNodeView } from "@/components/editor/nodeviews/TocNodeView";

export const TocBlock = Node.create({
  name: "tocBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      title: { default: "Table of Contents" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="toc-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "toc-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TocNodeView);
  },
});
